module.exports = __webpack_public_path__ + "images/calculator-cup_318ddad3c7b2ae27016fff0ad75cb984.png";